// sidebar.js

import React from 'react';
import { slide as Menu } from 'react-burger-menu';
import { Link } from 'react-router-dom';
import styles from './SideBar.module.scss'

export default props => {
  return (
    <Menu>
      <Link className={styles.menuitem} to="/">
        welcome
      </Link>
      <Link className={styles.menuitem} to="/about">
        about me
      </Link>
      <Link className={styles.menuitem} to="/gallery">
        gallery
      </Link>
      <Link className={styles.menuitem} to="/exhibitions">
        exhibitions
      </Link>
    </Menu>
  );
};